/* ============================================================
   gtx-smart-search.js — 官網内部スマート検索（2026-06-27 Round 151）
   ------------------------------------------------------------
   1 本の ERP 分級索引（erp.greentex.jp/account/search-index）を読み、
   入力を 5 意図に自動分類して「分類分組」表示する：
     品番 / 材質(上帝名單 日英中) / 公司(廠商, D/E のみ) / 題材 / 新品
   ＋ フォールバック 柄名(title 部分一致)。
   know-how：廠商は索引が D/E にしか返さない（前台は受け取った物しか出せない）。
   search.liquid と collection.liquid の両方から GTXSmartSearch.attach() で利用。
   ============================================================ */
(function () {
  "use strict";

  var ERP = "https://erp.greentex.jp";
  var IDX_URL = ERP + "/account/search-index";
  var CACHE_KEY = "gtx_search_idx_v1";
  var CACHE_TTL = 5 * 60 * 1000; // 5 分

  // ── 正規化：trim / 小文字 / 全角英数→半角 / 空白除去 ──
  function norm(s) {
    s = (s == null ? "" : String(s)).trim().toLowerCase();
    s = s.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (c) {
      return String.fromCharCode(c.charCodeAt(0) - 0xFEE0);
    });
    s = s.replace(/[　\s]+/g, "");
    s = s.replace(/號/g, "号").replace(/灣/g, "湾");   // R1105 繁中→日本の字（8號帆布→8号帆布）
    return s;
  }
  function esc(s) {
    return (s == null ? "" : String(s)).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  // ── 多語別名（curated extras：索引の ja/en/zh に上乗せ）──
  // 材質 family（番手違いを束ねる）への別名
  var MATERIAL_EXTRA = {
    "wガーゼ": "doublegauze", "ダブルガーゼ": "doublegauze", "二重ガーゼ": "doublegauze",
    "二重紗": "doublegauze", "雙層紗": "doublegauze", "doublegauze": "doublegauze",
    "tガーゼ": "triplegauze", "三層ガーゼ": "triplegauze", "三層紗": "triplegauze",
    "シングルガーゼ": "singlegauze", "単層紗": "singlegauze", "單層紗": "singlegauze",
    "ガーゼ": "gauze", "紗布": "gauze", "gauze": "gauze",
    "シーチング": "sheeting", "胚布": "sheeting", "平織棉": "sheeting", "sheeting": "sheeting",
    "オックス": "oxford", "牛津": "oxford", "牛津布": "oxford", "oxford": "oxford",
    "ツイル": "twill", "斜紋": "twill", "斜紋布": "twill", "twill": "twill",
    "ブロード": "broadcloth", "府綢": "broadcloth", "broad": "broadcloth", "broadcloth": "broadcloth",
    "キャンバス": "canvas", "帆布": "canvas", "canvas": "canvas",
    "ローン": "lawn", "細棉布": "lawn", "lawn": "lawn",
    "サテン": "satin", "緞布": "satin", "satin": "satin",
    "リネン": "linencanvas", "麻": "linencanvas", "linen": "linencanvas",
    "ジャガード": "jacquard", "提花": "jacquard", "提花布": "jacquard", "jacquard": "jacquard",
    /* 2026-07-03 Round165.2（D級嚴測遺留②）台灣慣用語補充 */
    "雙重紗": "doublegauze", "双層紗": "doublegauze",
    "三重紗": "triplegauze", "三層紗布": "triplegauze",
    /* 2026-07-29 Round245：CEO 実測で「雙紗」がヒットしないと発覚。
       「雙層紗／雙重紗」は入っていたが、一番よく使う短縮形「雙紗」が抜けていた。
       尾綴剥がし（雙紗布→雙紗）も効くので、この1語で布/料の付いた形も拾える。 */
    "雙紗": "doublegauze", "双紗": "doublegauze", "w紗": "doublegauze",
    "二重紗布": "doublegauze", "雙面紗": "doublegauze",
    "三紗": "triplegauze", "三重紗布": "triplegauze", "t紗": "triplegauze",
    "厚棉": "heavysheeting", "厚手": "heavysheeting", "厚胚布": "heavysheeting", "厚平織棉": "heavysheeting", "厚手シーチング": "heavysheeting",
    "絨布": "corduroy", "燈芯絨": "corduroy",
    "針織": "knit", "ニット": "knit",
    "網布": "mesh", "網眼": "mesh"
  };
  // 題材キーへの別名
  var THEME_EXTRA = {
    "ねこ": "cat", "ネコ": "cat", "cat": "cat", "kitty": "cat",
    "いぬ": "dog", "イヌ": "dog", "dog": "dog",
    "とり": "bird", "トリ": "bird", "bird": "bird",
    "さかな": "fish", "fish": "fish",
    "どうぶつ": "animal", "アニマル": "animal", "animal": "animal",
    "むし": "insect", "insect": "insect", "bug": "insect",
    "きょうりゅう": "dinosaur", "dinosaur": "dinosaur", "dino": "dinosaur",
    "はな": "botanical", "花": "botanical", "flower": "botanical", "floral": "botanical",
    "ボタニカル": "botanical", "plant": "botanical", "植物": "botanical",
    "おおばな": "flower_big", "こばな": "flower_small",
    "きか": "geometric", "幾何学": "geometric", "geometric": "geometric", "geo": "geometric",
    "わふう": "japanese", "和柄": "japanese", "japanese": "japanese", "japan": "japanese",
    "ちゅうか": "chinese", "中華": "chinese", "chinese": "chinese",
    "ちゅうしょう": "abstract", "abstract": "abstract",
    "もじ": "text", "text": "text", "letter": "text", "typography": "text",
    "どうぐ": "tool", "tool": "tool",
    "じんぶつ": "person", "people": "person", "person": "person",
    "ふうけい": "landscape", "landscape": "landscape", "scenery": "landscape",
    "のりもの": "vehicle", "vehicle": "vehicle", "car": "vehicle",
    "たいわん": "taiwan", "台湾": "taiwan", "台灣": "taiwan", "taiwan": "taiwan", "formosa": "taiwan",
    "スポーツ": "sports", "sport": "sports", "sports": "sports",
    "むじ": "plain", "plain": "plain", "solid": "plain",
    "たべもの": "food", "食べ物": "food", "食物": "food", "food": "food",
    "素材": "texture", "texture": "texture"
  };
  // 公司（廠商, D/E）別名 → vendor 文字列に含まれる部分文字列
  var VENDOR_EXTRA = {
    "kobayashi": "小林", "こばやし": "小林", "小林": "小林",
    "kokka": "コッカ", "コッカ": "コッカ", "cocca": "コッカ",
    "cosmo": "コスモ", "コスモ": "コスモ", "コスモテキスタイル": "コスモ",
    "kaiyo": "kaiyo",
    "kei": "kei",
    "ktex": "ktex",
    "cocotex": "cocotex",
    "homespun": "ホームスパン", "ホームスパン": "ホームスパン",
    "swany": "スワニー", "スワニー": "スワニー", "鎌倉": "スワニー"
  };
  // 新品キーワード
  var NEW_WORDS = { "新品": 1, "新柄": 1, "新作": 1, "新着": 1, "最新": 1, "new": 1, "newarrival": 1, "新貨": 1 };

  // ── 索引取得（sessionStorage キャッシュ）──
  function loadIndex() {
    return new Promise(function (resolve) {
      try {
        var raw = sessionStorage.getItem(CACHE_KEY);
        if (raw) {
          var o = JSON.parse(raw);
          if (o && o._t && (Date.now() - o._t < CACHE_TTL) && o.data) {
            return resolve(o.data);
          }
        }
      } catch (e) {}
      fetch(IDX_URL, { credentials: "include" })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (!d || !d.ok) return resolve(null);
          try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ _t: Date.now(), data: d })); } catch (e) {}
          resolve(d);
        })
        .catch(function () { resolve(null); });
    });
  }

  // ── 索引から runtime 辞書を組む ──
  function buildDicts(idx) {
    var matAlias = {};   // norm(alias) -> family
    (idx.materials || []).forEach(function (m) {
      if (m.fam) {
        [m.ja, m.en, m.zh].forEach(function (w) {
          if (w) matAlias[norm(w)] = m.fam;
        });
      }
    });
    Object.keys(MATERIAL_EXTRA).forEach(function (k) { matAlias[norm(k)] = MATERIAL_EXTRA[k]; });

    var themeAlias = {}; // norm(alias) -> key
    (idx.themes || []).forEach(function (t) {
      [t.ja, t.zh, t.en, t.key].forEach(function (w) { if (w) themeAlias[norm(w)] = t.key; });
    });
    Object.keys(THEME_EXTRA).forEach(function (k) { themeAlias[norm(k)] = THEME_EXTRA[k]; });

    var codeSet = {};
    (idx.items || []).forEach(function (it) { codeSet[norm(it.c)] = 1; });

    return { matAlias: matAlias, themeAlias: themeAlias, codeSet: codeSet };
  }

  // ── 品番マッチ（完全/前方/部分）──
  function matchCode(q, items) {
    var exact = [], prefix = [], contains = [];
    for (var i = 0; i < items.length; i++) {
      var cc = norm(items[i].c);
      if (cc === q) exact.push(items[i]);
      else if (cc.indexOf(q) === 0) prefix.push(items[i]);
      else if (q.length >= 4 && cc.indexOf(q) >= 0) contains.push(items[i]);
    }
    return { exact: exact, prefix: prefix, contains: contains };
  }

  // ── 長さ記号（H/L/S）剝がし。ERP 側 services/code_alias.py と同一規則。
  //    「数字で終わる幹 ＋ H/L/S」だけを対象（CCCA0680-01 等は対象外）。
  function stripLenSuffix(q) {
    var m = /^(.*?[0-9])([hls]+)$/.exec(q);
    if (!m) return null;
    return m[1].length >= 2 ? m[1] : null;
  }

  // ── 入力 → 分類して各グループの items を返す ──
  // R1105 産地語（何も出ない時だけ外して再検索）
  var ORIGIN_RE_HEAD = /^(日本製|日本産|日本|台湾製|台湾|japanese|japan|madeinjapan|和製)/;
  var ORIGIN_RE_TAIL = /(日本製|日本産|台湾製)$/;
  function search(query, idx, dicts) {
    var r = search0(query, idx, dicts), n = 0;
    r.forEach(function (g) { n += g.items.length; });
    if (n) return r;
    var q = norm(query), q2 = q.replace(ORIGIN_RE_HEAD, "").replace(ORIGIN_RE_TAIL, "");
    if (q2 && q2 !== q) return search0(q2, idx, dicts);
    return r;
  }
  function pnHas(it, w) { return norm((it.pn || "") + " " + (it.t || "")).indexOf(w) >= 0; }
  function search0(query, idx, dicts) {
    var q = norm(query);
    var items = idx.items || [];
    var groups = [];
    var used = {}; // code -> 1（重複表示防止：上位グループ優先）

    function pushGroup(type, label, list) {
      var fresh = [];
      for (var i = 0; i < list.length; i++) {
        var c = list[i].c;
        if (used[c]) continue;
        used[c] = 1;
        fresh.push(list[i]);
      }
      if (fresh.length) groups.push({ type: type, label: label, items: fresh });
    }

    if (!q) return groups;

    // 1) 品番（完全一致→前方一致）。雑訊抑制：英数主体のときだけ品番判定。
    var looksCode = /^[a-z0-9\-]{2,}$/.test(q);
    if (looksCode) {
      var hit = matchCode(q, items);
      if (!hit.exact.length && !hit.prefix.length && !hit.contains.length) {
        // ── R335（CEO 2026-08-19・LIKE CHING 事件）────────────────
        // 客は仕入先カタログ表記のまま「AP4187H」と打つ。H/L/S は長さ記号
        // （12M半 / 36M / 12Mマル）で、弊社の母品番は「AP4187」。
        // 尾綴が付いただけで 0 件＝在庫があるのに売り逃す事故だった。
        // 【0 件のときだけ】剝がして 1 回だけ再照合（従来挙動は不変・誤爆ゼロ）。
        var stem = stripLenSuffix(q);
        if (stem) {
          var h2 = matchCode(stem, items);
          if (h2.exact.length || h2.prefix.length || h2.contains.length) {
            var lbl = L("code", idx) + "（" + esc(query) + " → " + esc(stem) + "）";
            if (h2.exact.length) pushGroup("code", lbl, h2.exact);
            else { pushGroup("code", lbl, h2.prefix); pushGroup("code", lbl, h2.contains); }
          }
        }
      } else if (hit.exact.length) {
        // 雑訊抑制の肝：完全一致があれば前方/部分一致は出さない（CEO：全碼検索で無関係が大量に出る）
        pushGroup("code", L("code_exact", idx), hit.exact);
      } else {
        pushGroup("code", L("code", idx), hit.prefix);
        pushGroup("code", L("code", idx), hit.contains);
      }
    }

    // 2) 材質（family 一致）
    // 2026-07-03 Round165.2：尾綴剥がし再照合（「二重紗布」「牛津布料」等 →「二重紗」「牛津」）。
    var fam = dicts.matAlias[q], qm = "";
    if (!fam) {
      qm = q.replace(/(布料|生地|の生地|布)$/, "");
      if (qm && qm !== q) fam = dicts.matAlias[qm];
    }
    if (fam) {
      // 包含比対：通称「ガーゼ」(fam=gauze) は doublegauze/triplegauze/singlegauze も束ねる。
      // R1105 商品名に材質語を含む品も（川島の帆布は material_code 空で mf が無い）。2 字以上の語だけ。
      var mw = dicts.matAlias[q] ? q : (qm || q);
      var ml = items.filter(function (it) { return (it.mf && it.mf.indexOf(fam) >= 0) || (mw.length >= 2 && pnHas(it, mw)); });
      pushGroup("material", L("material", idx) + "：" + esc(query), ml);
    } else {
      // R1105 材質語＋残り（「8号帆布」「帆布8号」「綿帆布」）：一番長い材質語を見つけ、残りで絞る
      var best = "";
      Object.keys(dicts.matAlias).forEach(function (k) { if (k.length >= 2 && k.length > best.length && q.indexOf(k) >= 0) best = k; });
      if (best) {
        var rest = q.replace(best, "").replace(/(布料|生地|の生地|布)$/, ""), f2 = dicts.matAlias[best];
        var cand = items.filter(function (it) { return (it.mf && it.mf.indexOf(f2) >= 0) || pnHas(it, best); });
        if (rest) {
          var rre = /^[0-9]/.test(rest) ? new RegExp("(^|[^0-9])" + rest.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")) : null;
          cand = cand.filter(function (it) { var tx = norm((it.pn || "") + " " + (it.t || "")); return rre ? rre.test(tx) : tx.indexOf(rest) >= 0; });
        }
        pushGroup("material", L("material", idx) + "：" + esc(query), cand);
      }
    }

    // 3) 題材（同じく尾綴剥がし：「動物柄」「和風圖案」→「動物」「和風」）
    var tk = dicts.themeAlias[q];
    if (!tk) {
      var qt = q.replace(/(圖案|图案|模様|パターン|柄)$/, "");
      if (qt && qt !== q) tk = dicts.themeAlias[qt];
    }
    if (tk) {
      var tl = items.filter(function (it) { return (it.th || []).indexOf(tk) >= 0; });
      pushGroup("theme", L("theme", idx) + "：" + esc(query), tl);
    }

    // 4) 公司（廠商, D/E のみ：索引に v がある時だけ機能）
    if (idx.vendor_visible) {
      var vsub = VENDOR_EXTRA[q] ? norm(VENDOR_EXTRA[q]) : q;
      var vl = items.filter(function (it) { return it.v && norm(it.v).indexOf(vsub) >= 0; });
      if (vl.length) pushGroup("vendor", L("vendor", idx) + "：" + esc(query), vl);
    }

    // 4.5) シリーズ（HOYOKA 等の公開ブランド名。Round 314：全級で検索可）
    //      メーカー実名（D/E 限定）とは別枠。索引側 it.br に入る。
    var bl = items.filter(function (it) { return it.br && norm(it.br).indexOf(q) >= 0; });
    if (bl.length) pushGroup("series", L("series", idx) + "：" + esc(query), bl);

    // 5) 新品
    if (NEW_WORDS[q]) {
      var nl = items.filter(function (it) { return it.nw; });
      pushGroup("new", L("new", idx), nl);
    }

    // 6) フォールバック：柄名(title) 部分一致
    // R631（2026-09-16）柄名も見る。日本布は Shopify の title が品番なので
    // it.t だけ見ていると「Boa」「Linnea」等の柄名検索が全部 0 件になっていた。
    var fl = items.filter(function (it) {
      if (it.t && norm(it.t).indexOf(q) >= 0) return true;
      return !!(it.pn && norm(it.pn).indexOf(q) >= 0);
    });
    pushGroup("text", L("text", idx) + "：" + esc(query), fl);

    return groups;
  }

  // ── ラベル（D/E=繁中、その他=日本語）──
  var LABELS = {
    ja: { code_exact: "品番（完全一致）", code: "品番", material: "素材", theme: "テーマ", vendor: "メーカー", series: "シリーズ", new: "新着", text: "柄名" },
    zh: { code_exact: "品番（完全符合）", code: "品番", material: "材質", theme: "題材", vendor: "廠商", series: "系列", new: "新品", text: "柄名" }
  };
  function L(k, idx) {
    var lang = (idx && (idx.tier === "D" || idx.tier === "E")) ? "zh" : "ja";
    return LABELS[lang][k] || k;
  }

  // ── カード HTML（既存 .tx-card に揃える）──
  function cardHTML(it, idx) {
    var img = it.img || "";
    if (img) img = img + (img.indexOf("?") >= 0 ? "&" : "?") + "width=400";
    var newBadge = it.nw ? '<span class="tx-card-new">NEW</span>' : "";
    var vendor = (idx.vendor_visible && it.v) ? '<span class="gtx-sr-vendor">' + esc(it.v) + "</span>" : "";
    var url = "/products/" + encodeURIComponent(it.h);
    return '<a class="tx-card" href="' + url + '" aria-label="' + esc(it.t) + '">' +
      '<div class="tx-card-cover">' + newBadge +
        (img ? '<img src="' + esc(img) + '" alt="' + esc(it.t) + '" loading="lazy" width="400" height="400">' : "") +
      '</div>' +
      '<div class="tx-card-body">' +
        '<p class="tx-card-code">' + esc(it.c) + "</p>" +
        // R631：柄名があれば柄名を出す。日本布は t＝品番なので
        //       そのままだと品番が 2 行並ぶだけでカードから何も分からなかった。
        '<p class="tx-card-name">' + esc(it.pn || it.t) + "</p>" +
        vendor +
      "</div>" +
    "</a>";
  }

  function renderGroups(groups, idx) {
    if (!groups.length) {
      return '<div class="gtx-sr-empty">' +
        ((idx && (idx.tier === "D" || idx.tier === "E"))
          ? "找不到符合的結果，請換個關鍵字（品番／材質／題材／廠商／新品）。"
          : "該当する結果がありません。別のキーワードでお試しください（品番・素材・テーマ・メーカー・新着）。") +
        "</div>";
    }
    var html = "";
    groups.forEach(function (g) {
      html += '<section class="gtx-sr-group">' +
        '<h3 class="gtx-sr-grouptitle">' + g.label +
          ' <span class="gtx-sr-count">' + g.items.length + "</span></h3>" +
        '<div class="tx-grid">';
      g.items.forEach(function (it) { html += cardHTML(it, idx); });
      html += "</div></section>";
    });
    return html;
  }

  // ── 公開 API ──
  var STATE = { idx: null, dicts: null };

  function ensureIndex() {
    if (STATE.idx) return Promise.resolve(STATE.idx);
    return loadIndex().then(function (idx) {
      if (idx) { STATE.idx = idx; STATE.dicts = buildDicts(idx); }
      return idx;
    });
  }

  /* attach({input, results, normalView, onActiveChange})
     - input: 検索 input 要素
     - results: 結果を描く空コンテナ
     - normalView: クエリ空のとき表示する通常グリッド（任意）
     - chips: テーマ/新着 ショートカットを入れるコンテナ（任意） */
  function attach(opts) {
    var input = opts.input, results = opts.results, normalView = opts.normalView;
    if (!input || !results) return;
    var timer;

    function run() {
      var q = input.value || "";
      if (!q.trim()) {
        results.innerHTML = "";
        results.style.display = "none";
        if (normalView) normalView.style.display = "";
        if (opts.onActiveChange) opts.onActiveChange(false, "");
        return;
      }
      ensureIndex().then(function (idx) {
        if (!idx) {
          results.style.display = "";
          results.innerHTML = '<div class="gtx-sr-empty">検索準備中です。少し待って再度お試しください。</div>';
          return;
        }
        var groups = search(q, idx, STATE.dicts);
        results.innerHTML = renderGroups(groups, idx);
        results.style.display = "";
        if (normalView) normalView.style.display = "none";
        if (opts.onActiveChange) opts.onActiveChange(true, q);
      });
    }

    input.addEventListener("input", function () {
      clearTimeout(timer);
      timer = setTimeout(run, 180);
    });
    // chips → 入力に流して検索
    if (opts.chips) {
      opts.chips.addEventListener("click", function (e) {
        var b = e.target.closest("[data-gtx-q]");
        if (!b) return;
        e.preventDefault();
        input.value = b.getAttribute("data-gtx-q");
        run();
        input.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }
    // 初期クエリ（?q=）
    if (opts.initialQuery) { input.value = opts.initialQuery; run(); }
    // 先読み（クリック前に索引を温める）
    ensureIndex();
  }

  window.GTXSmartSearch = {
    attach: attach,
    ensureIndex: ensureIndex,
    render: function (q) { return renderGroups(STATE.idx ? search(q, STATE.idx, STATE.dicts) : [], STATE.idx); },   // R1119 首頁の書棚の下に結果一覧
    search: function (q) { return STATE.idx ? search(q, STATE.idx, STATE.dicts) : []; },
    _norm: norm,
    _stripLenSuffix: stripLenSuffix
  };
})();
